import { useEffect, useRef, useState, type ReactNode } from 'react';

/** Caja de preview: escala el contenido (w×h reales) para que quepa en su
 *  columna manteniendo el ratio. El nodo real sigue a tamaño completo para
 *  html2canvas (que captura aparte un gemelo fuera de pantalla). */
export function Preview({ w, h, children }: { w: number; h: number; children: ReactNode }) {
  const wrapRef = useRef<HTMLDivElement | null>(null);
  const [scale, setScale] = useState(0.4);
  useEffect(() => {
    const el = wrapRef.current;
    if (!el) return;
    const update = () => setScale(el.clientWidth / w);
    update();
    const ro = new ResizeObserver(update);
    ro.observe(el);
    return () => ro.disconnect();
  }, [w]);
  return (
    <div
      ref={wrapRef}
      style={{
        width: '100%',
        maxWidth: h > w ? 380 : undefined,
        aspectRatio: `${w} / ${h}`,
        position: 'relative',
        overflow: 'hidden',
        borderRadius: 'var(--ld-radius-md)',
        border: '1px solid var(--ld-line)',
      }}
    >
      <div style={{ position: 'absolute', top: 0, left: 0, width: w, height: h, transform: `scale(${scale})`, transformOrigin: 'top left' }}>
        {children}
      </div>
    </div>
  );
}
